import { SelectOptionProps } from 'modules/ui/select/Select';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ValidationType } from '../../../types/ValidationType';

export function useSelectValidator() {
  const { t } = useTranslation();

  const validateField = useCallback(
    (values: SelectOptionProps[], validationList: ValidationType[]) => {
      if (validationList.includes(ValidationType.REQUIRED)) {
        if (values.length === 0) {
          return t('validation.requiredError');
        }
      }
      return undefined;
    },
    [t],
  );
  return validateField;
}
